import { defaultInputProps } from '../../../../FormContainer/defaultFormStates';
import { siteOptions } from '../../../../common/commonRequests';
import ValidateWeightedForm from '../validation/validation';

export const verticalSelect = () => ({
  site: {
    ...defaultInputProps,
    type: 'select',
    options: () => siteOptions(),
    value: '2',
    defaultVal: '2',
    name: 'site',
    label: 'Vertical'
  }
});

export const updateFormWeightState = () => ({
  form: {
    ...defaultInputProps,
    name: 'form',
    type: 'select',
    options: () => [],
    label: 'Form Name',
    value: '0',
    defaultVal: '0'
  },
  weight: {
    ...defaultInputProps,
    inputType: 'number',
    name: 'weight',
    label: 'Weight',
    dependencyName: 'form',
    adornmentPosition: 'end',
    adornment: '%',
    validate: ValidateWeightedForm.nonNegativeNumber
  },
  addWeight: {
    type: 'underForm',
    hidden: true
  }
});
